import { create } from "zustand";

interface ThreadState {
  activeThreadId: string | null;
  sidebarOpen: boolean;

  setActiveThreadId: (id: string | null) => void;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
}

export const useThreadStore = create<ThreadState>((set) => ({
  activeThreadId: null,
  sidebarOpen: true,

  setActiveThreadId: (id) => set({ activeThreadId: id }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
}));
